<template>
  <button
    :aria-label="
      bgVideoIsPlaying ? 'Pause background video' : 'Play background video'
    "
    :aria-pressed="bgVideoIsPlaying ? 'false' : 'true'"
    data-gtm-bg-video-btn
    class="flex-c p-2 bg-white focus-a z-10"
    @click="toggleVideo"
  >
    <span class="flex-a">
      <IconBase
        :icon="bgVideoIsPlaying ? 'PauseIcon' : 'PlayIcon'"
        :color="`primary`"
        :size="`1.2rem`"
      />
    </span>
  </button>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'BtnBgVideo',

  components: {
    IconBase
  },

  computed: {
    ...mapState(['touch', 'mobile', 'bgVideoIsPlaying']),
    ...mapGetters([])
  },

  methods: {
    toggleVideo() {
      if (!this.bgVideoIsPlaying) {
        this.$store.commit('toggleBgVideoState', true)
        this.$store.commit('toggleBgVideoPrevState', true)
      } else {
        this.$store.commit('toggleBgVideoState', false)
        this.$store.commit('toggleBgVideoPrevState', false)
      }
    }
  }
}
</script>
